import './styles.scss'

const TITLE = "We're automatically saving your changes"

const calculate = draft => {
  if (!draft) {
    return null
  }

  if (draft.getting) {
    return {
      label: 'Connecting...',
      icon: 'fa fa-spinner',
      title: TITLE
    }
  }

  if (draft.get) {
    return {
      label: 'Ready to go',
      icon: 'fa fa-check-circle',
      title: TITLE
    }
  }

  if (draft.setting) {
    return {
      label: 'Saving changes',
      icon: 'fa fa-spinner',
      title: TITLE
    }
  }

  if (draft.publishing) {
    return {
      label: 'Publishing changes',
      icon: 'fa fa-spinner',
      title: TITLE
    }
  }

  if (draft.set) {
    return {
      label: 'Changes saved',
      icon: 'fa fa-check-circle',
      title: TITLE
    }
  }

  if (draft.error) {
    const detail = draft?.error?.response?.data?.error?.detail
    return {
      label: 'Error',
      icon: 'fa fa-exclamation-circle',
      title: `${detail || draft.error}`,
      class: 'error'
    }
  }

  return null
}

export const DraftButton = ({ draft }) => {
  if (!draft) {
    return null
  }

  const state = calculate(draft)

  if (!state) {
    return null
  }

  return (
    <button
      type='button'
      name='nh-button'
      data-cy='draft-btn'
      className={`nh-draft-button ${state.class || ''}`}
      title={state.title}
    >
      <i className={`icon ${state.icon}`} />
      {state.label}
    </button>
  )
}
